import { useCallback, useMemo } from "react"

import { Menu, ListItemIcon } from "@mui/material"

import { PropTypes } from "@l2r-front/l2r-proptypes"

import * as Styled from "./L2RMenu.styled"

export const L2RMenu = (props) => {
    const {
        anchorEl,
        onClose,
        open,
        menuConfig,
        ...menuProps
    } = props

    const MenuItems = useMemo(() => {
        return menuConfig?.map((menuItem, index) => {
            const handleClick = (event) => {
                event.stopPropagation()
                if (menuItem.props?.onClick) {
                    menuItem.props.onClick(event)
                }
            }
            return <Styled.MenuItem key={index} id={menuItem.id} onClick={handleClick} {...menuItem.props}>
                {menuItem.icon && <ListItemIcon>
                    {menuItem.icon}
                </ListItemIcon>
                }
                <Styled.ListItemText>
                    {menuItem.label}
                </Styled.ListItemText>
            </Styled.MenuItem>
        })
    }, [menuConfig])

    const handleClose = useCallback((event) => {
        event.stopPropagation()
        onClose()
    }, [onClose])

    return <Styled.Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        {...menuProps}>
        {MenuItems}
    </Styled.Menu >
}

L2RMenu.propTypes = {
    ...Menu.propTypes,
    menuConfig: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        label: PropTypes.string.isRequired,
        icon: PropTypes.node,
        props: PropTypes.object,
    })),
}